import { useCallback, useEffect, useState } from "react";

const KEY = "heiren_history";

export interface HistoryItem {
  id: string;
  viewedAt: number;
}

function read(): HistoryItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as HistoryItem[]) : [];
  } catch {
    return [];
  }
}

export function useHistory() {
  const [history, setHistory] = useState<HistoryItem[]>([]);

  useEffect(() => {
    setHistory(read());
  }, []);

  const record = useCallback((id: string) => {
    setHistory((prev) => {
      const filtered = prev.filter((item) => item.id !== id);
      const next = [{ id, viewedAt: Date.now() }, ...filtered].slice(0, 20);
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        /* ignore storage errors */
      }
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify([]));
    } catch {
      /* ignore storage errors */
    }
    setHistory([]);
  }, []);

  return { history, record, clear };
}